import {
  type FilterInput,
  LogicalOperator,
  OperatorOption,
} from '@/components/publicSearch/constants';
import { hasWildcardChars } from '@/components/publicSearch/search/animalIdentChipFilter';
import { tryExpandFilterInputToComparisonRows } from '@/components/publicSearch/search/searchFilterEbvExpansion';
import type {
  ComparisonOperator,
  FilterGroupOfSaleFilteredFilterOptionInput,
  SaleFilterField,
  SaleFilteredFilterOptionInput,
} from '@/graphqlClient/types';

export function buildSaleSearchFilterGroup(
  filters: FilterInput[],
  commonFilterOperator: LogicalOperator,
): FilterGroupOfSaleFilteredFilterOptionInput {
  const processedFilters: SaleFilteredFilterOptionInput[] = [];
  const wildcardGroups: FilterGroupOfSaleFilteredFilterOptionInput[] = [];

  for (const { field, operator, value } of filters) {
    if (!field) continue;

    const expandedRows = tryExpandFilterInputToComparisonRows({
      field,
      operator,
      value,
    });
    if (expandedRows !== null) {
      const saleRows = expandedRows.map((row) => ({
        field: row.field as SaleFilterField,
        operator: row.operator as ComparisonOperator,
        value: row.value,
      }));

      if (!operator && hasWildcardChars(value) && expandedRows.length > 1) {
        wildcardGroups.push({
          filters: saleRows,
          logicalOperator: LogicalOperator.and,
        });
      } else {
        processedFilters.push(...saleRows);
      }
      continue;
    }

    if (!operator) continue;

    if (value || operator === OperatorOption.isNotEmpty.value) {
      processedFilters.push({
        field: field as SaleFilterField,
        operator: operator as ComparisonOperator,
        value,
      });
    }
  }

  return {
    filters: processedFilters,
    groups: wildcardGroups.length > 0 ? wildcardGroups : undefined,
    logicalOperator: commonFilterOperator,
  };
}
